module.exports = __webpack_public_path__ + "img/altar_of_fire_small.0ac6bb40.png";